import React from 'react';
import ReactTooltip from 'react-tooltip';
import { constants } from '../../../Helpers/Constants';
import colours from '../DesignSystem/Colours';
import Icon from '../DesignSystem/Icons/Icon';
import { VCTO, DepartmentPress, VCMTL, VCVAN, DepartmentFleet, DepartmentGeneral, DepartmentCompany, DepartmentMarketing, DepartmentTraining, UserFleet, UserDealer, UserPress, UserEmployee, DepartmentFleetSVG } from './Icons.js';



export function VCIcon(VMH, size, svg, noTooltip, noTooltipController) {
    svg = svg || "false";
    size = size || 20;

    if (!VMH) {
        return null;
    }
    if (VMH.Display_City === "Toronto") {
        return(
            <div style={{display: 'inline-flex'}} className="type-icon" data-tooltip={!noTooltip} tabIndex="1" data-tip={!noTooltip ? (VMH.Display_Name + "-" + VMH.Display_City) : null} data-position="bottom" data-alignment="center">
                <Icon name="VCToronto" size={size} style={{color: colours.functional.division_toronto}}/>
                {noTooltip || noTooltipController ? null : <ReactTooltip effect="solid" />}
            </div>
        )
    } else if (VMH.Display_City === "Montreal") {
        return(
            <div style={{display: 'inline-flex'}} className="type-icon" data-tooltip={!noTooltip} tabIndex="1" data-tip={!noTooltip ? (VMH.Display_Name + "-" + VMH.Display_City) : null} data-position="bottom" data-alignment="center">
                <Icon name="VCMontreal" size={size} style={{color: colours.functional.division_montreal}}/>
                {noTooltip || noTooltipController ? null : <ReactTooltip effect="solid" />}
            </div>
        )

    } else if (VMH.Display_City === "Vancouver") {
        return(
            <div style={{display: 'inline-flex'}} className="type-icon" data-tooltip={!noTooltip} tabIndex="1" data-tip={!noTooltip ? (VMH.Display_Name + "-" + VMH.Display_City) : null} data-position="bottom" data-alignment="center">
                <Icon name="VCVancouver" size={size} style={{color: colours.functional.division_vancouver}}/>
                {noTooltip || noTooltipController ? null : <ReactTooltip effect="solid" />}
            </div>
        )
    }
};

export function DivisionIcon(SH, size, svg, noTooltip, noTooltipController) {
    svg = svg || "false";
    size = size || 20;
    if (!SH) {
        return null;
    }
    if (SH.Category === 0) {
        return(
            <div style={{display: 'inline-flex'}} className="type-icon" data-tooltip={!noTooltip} tabIndex="1" data-tip={!noTooltip ? ((SH.Display_Name ? SH.Display_Name : SH.Company) + " " + SH.Division) : null} data-position="bottom" data-alignment="center">
                <Icon name="PoolFleet" size={size}/>
                {noTooltip || noTooltipController ? null : <ReactTooltip effect="solid" />}
            </div>
        )
    } else if (SH.Category === 1) {
        return(
            <div style={{display: 'inline-flex'}} className="type-icon" data-tooltip={!noTooltip} tabIndex="1" data-tip={!noTooltip ? ((SH.Display_Name ? SH.Display_Name : SH.Company) + " " + SH.Division) : null} data-position="bottom" data-alignment="center">
                <Icon name="PoolPress" size={size}/>
                {noTooltip || noTooltipController ? null : <ReactTooltip effect="solid" />}
            </div>
        )
    } else if (SH.Category === 2) {
        return(
            <div style={{display: 'inline-flex'}} className="type-icon" data-tooltip={!noTooltip} tabIndex="1" data-tip={!noTooltip ? ((SH.Display_Name ? SH.Display_Name : SH.Company) + " " + SH.Division) : null} data-position="bottom" data-alignment="center">
                <Icon name="PoolPress" size={size}/>
                {noTooltip || noTooltipController ? null : <ReactTooltip effect="solid" />}
            </div>
           
        )
    } else if (SH.Category === 3) {
        return(
            <div style={{display: 'flex'}} className="type-icon" data-tooltip={!noTooltip} tabIndex="1" data-tip={!noTooltip ? ((SH.Display_Name ? SH.Display_Name : SH.Company) + " " + SH.Division) : null} data-position="bottom" data-alignment="center">
                <Icon name="PoolPress" size={size}/>
                {noTooltip || noTooltipController ? null : <ReactTooltip effect="solid" />}
            </div>
            
        )
    } else if (SH.Category === 4) {
        return(
            <div style={{display: 'inline-flex'}} className="type-icon" data-tooltip={!noTooltip} tabIndex="1" data-tip={!noTooltip ? ((SH.Display_Name ? SH.Display_Name : SH.Company) + " " + SH.Division) : null} data-position="bottom" data-alignment="center">
                <Icon name="PoolGeneral" size={size}/>
                {noTooltip || noTooltipController ? null : <ReactTooltip effect="solid" />}
            </div>
            
        )
    } else if (SH.Category === 5) {
        return(
            <div style={{display: 'inline-flex'}} className="type-icon" data-tooltip={!noTooltip} tabIndex="1" data-tip={!noTooltip ? ((SH.Display_Name ? SH.Display_Name : SH.Company) + " " + SH.Division) : null} data-position="bottom" data-alignment="center">
                <Icon name="PoolCompany" size={size}/>
                {noTooltip || noTooltipController ? null : <ReactTooltip effect="solid" />}
            </div>
            
        )
    } else if (SH.Category === 6) {
        return(
            <div style={{display: 'inline-flex'}} className="type-icon" data-tooltip={!noTooltip} tabIndex="1" data-tip={!noTooltip ? ((SH.Display_Name ? SH.Display_Name : SH.Company) + " " + SH.Division) : null} data-position="bottom" data-alignment="center">
                <Icon name="PoolMarketing" size={size}/>
                {noTooltip || noTooltipController ? null : <ReactTooltip effect="solid" />}
            </div>
            
        )
    } else if (SH.Category === 7) {
        return(
            <div style={{display: 'inline-flex'}} className="type-icon" data-tooltip={!noTooltip} tabIndex="1" data-tip={!noTooltip ? ((SH.Display_Name ? SH.Display_Name : SH.Company) + " " + SH.Division) : null} data-position="bottom" data-alignment="center">
                <Icon name="PoolTesting" size={size}/>
                {noTooltip || noTooltipController ? null : <ReactTooltip effect="solid" />}
            </div>
            
        )
    }
};

export function UserRoleIcon(Role) {
    if (Role === constants.user_role.fleet_buyer) {
        return(UserFleet())
    } else if (Role === constants.user_role.media_influencer) {
        return(UserPress())
    } else if (Role === constants.user_role.employee) {
        return(UserEmployee())
    } else if (Role === constants.user_role.dealer) {
        return(UserDealer())
    } else if (Role === constants.user_role.integrated_client) {
        return(UserPress())
    } else if (Role === constants.user_role.viewing_user) {
        return(UserPress())
    } else if (Role === constants.user_role.admin) {
        return(UserPress())
    }
}